module.exports = __webpack_public_path__ + "img/vip_alipay_selected.79dc86fa.svg";